exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-deal-status_transitions-components-DealFinalizingConfirmation-___style__header___3lMM-{display:flex;justify-content:space-between;border-bottom:1px solid #e5e3e3}.web-flows-deal-status_transitions-components-DealFinalizingConfirmation-___style__h2___2uQHu{border-bottom:none!important}.web-flows-deal-status_transitions-components-DealFinalizingConfirmation-___style__close___30Pfk{padding:0 .7em .7em 0}@media (min-width:599px){.web-flows-deal-status_transitions-components-DealFinalizingConfirmation-___style__content___2f4eu{width:600px}}@media (max-width:599px){.web-flows-deal-status_transitions-components-DealFinalizingConfirmation-___style__toplevel___2KnCQ{padding:1em .5em 0}}", ""]);

// exports
exports.locals = {
	"header": "web-flows-deal-status_transitions-components-DealFinalizingConfirmation-___style__header___3lMM-",
	"h2": "web-flows-deal-status_transitions-components-DealFinalizingConfirmation-___style__h2___2uQHu",
	"close": "web-flows-deal-status_transitions-components-DealFinalizingConfirmation-___style__close___30Pfk",
	"content": "web-flows-deal-status_transitions-components-DealFinalizingConfirmation-___style__content___2f4eu",
	"toplevel": "web-flows-deal-status_transitions-components-DealFinalizingConfirmation-___style__toplevel___2KnCQ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/deal/status_transitions/components/DealFinalizingConfirmation/style.css
// module id = 1350
// module chunks = 0